import { Roles } from "../constants";
import { APP_ROUTES } from "../helpers/routeHelpers";
import CustomerManagementIconDark from "../assets/images/app/common/customer-mana-icon-dark.svg";
import FeedbackIconDark from "../assets/images/app/common/feedback-icon-dark.svg";
import NotificationIconDark from "../assets/images/app/common/bell-icon-dark.svg";
import AnalyticsIconDark from "../assets/images/app/common/analytics-icon-dark.svg";

let { Admin, SuperAdmin } = Roles;

const SIDEBAR_CONFIG = [
  {
    title: "BLS Feedback",
    url: APP_ROUTES.BLS_FEEDBACK,
    icon: null,
    menuImg: FeedbackIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Customer Management",
    url: APP_ROUTES.CUSTOMER_MANAGEMENT,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Notification Management",
    url: APP_ROUTES.NOTIFICATION_MANAGEMENT,
    icon: null,
    menuImg: NotificationIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Click Analytics",
    url: APP_ROUTES.CLICK_ANALYTICS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "User Analytics",
    url: APP_ROUTES.USER_ANALYTICS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
];

export default SIDEBAR_CONFIG;
